/**
 * @generated SignedSource<<8aba29eb9bbd48ceb56c80eb7691b5fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PostVoteType = "DOWN" | "NONE" | "UP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type postBottomActionsFragment$data = {
  readonly author: {
    readonly id: string;
  } | null | undefined;
  readonly commentCount: number;
  readonly id: string;
  readonly slug: string;
  readonly space: {
    readonly slug: string;
  } | null | undefined;
  readonly url: string | null | undefined;
  readonly userVote: {
    readonly vote: PostVoteType;
  } | null | undefined;
  readonly votes: number;
  readonly " $fragmentType": "postBottomActionsFragment";
};
export type postBottomActionsFragment$key = {
  readonly " $data"?: postBottomActionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postBottomActionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postBottomActionsFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PostVote",
      "kind": "LinkedField",
      "name": "userVote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vote",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "daea11beec6d225eeafb21d87c59beed";

export default node;
